module.exports = __webpack_public_path__ + "static/media/Icon 3.b69f27bd.jpeg";